const displayOwnAd = ( data, path ) => {
    return data && data.filter( line => {
        return (`/${ line.acronym }${ line.portal_path === '/§' ? '' : line.portal_path }` === path ) 
    });
}

const displayParentAd = (data, path) => {
    return data && data.filter( line => path.includes(line.portal_path));
}

export const filterAds = ( data, position, pathname ) => {
    const path = pathname && (pathname.includes('/') ? pathname : `/${ pathname }`);
    const ownAd = displayOwnAd( data, path );
    const parentAd = displayParentAd( data, path );

    // console.log( "PATH", path );
    // console.log( "OWN AD", ownAd );
    // console.log( "PARENT AD", parentAd );

    return (ownAd && ownAd.length && ownAd) || ( parentAd && parentAd.length && parentAd) || [];
}

export 	const slotPositionId = ( pathname ) => {
    if (pathname.includes('media')) return 3;
    if (pathname.includes('podcasts')) return 3;
    if (pathname.includes('forums')) return 3;
    if (pathname.includes('jobs')) return 3;
    if (pathname.length <= 4) return 2;
    else return 1;
}

export const addSlotsToPodcasts = (podArr, step, networkId) => {
    let newArr = podArr.slice();
    const advertArr = [{ position: 1, type:'mpu', networkId }, { position: 2, type:'mpu', networkId }];

    newArr.splice(step, 0, advertArr[0]);
    newArr.splice((step + 6) + 1, 0, advertArr[1]);
    return newArr;
}


export const addSlotsToJobs = ( jobsArr, step, networkId = 1 ) => {
    let newArr = jobsArr.slice();

    const advertArr = [{ position: 1, type:'mpu', networkId }, { position: 2, type:'mpu', networkId }];
    // const advertArr = [{ position: 1, type:'mpu', networkId }];

    newArr.splice(step, 0, advertArr[0]);
    
    // console.log( "NEW ARRAY MODIFIED!!! ", newArr );
    newArr.splice((step + 9), 0, advertArr[1] );
    return newArr;
};



// WEBPACK FOOTER //
// src/client/components/common/adverts/googleDFP/lib/helpers.js